import React, {useRef, useState} from 'react'
import {useQuery} from '@apollo/client'
import AutoForm from '@components/AutoForm'
import Button from '@components/Button'
import useWebsiteId from '@hooks/useWebsiteId'
import Container from '@packages/justo-parts/lib/components/Container'
import gql from 'graphql-tag'
import {useTranslation} from 'next-i18next'

import Ready from './Ready'

import styles from './root/styles.module.css'

interface ReservationDoc {
  websiteId: string
  name?: string
  phone?: string
  email?: string
}

export default function Reservation() {
  const websiteId = useWebsiteId()
  const form = useRef(null)
  const [result, setResult] = useState()

  const {t} = useTranslation('website', {keyPrefix: 'reserve'})
  const doc: ReservationDoc = {websiteId}

  const {data: me} = useQuery(gql`
    query getMeReservation {
      me {
        _id
        phone
        email
        fullName
      }
    }
  `)

  if (result) return <Ready result={result} />

  if (me) {
    doc.name = me.fullName
    doc.phone = me.phone
    doc.email = me.email
  }

  return (
    <div className={styles.container}>
      <Container size="small">
        <h1>{t('labelMakeReserve')}</h1>
        <br />
        <AutoForm
          omit="websiteId"
          mutation="createReservation"
          ref={form}
          doc={doc}
          onSuccess={result => setResult(result)}
        />
        <br />
        <Button onClick={() => form.current?.submit()}>{t('labelCreateReserve')}</Button>
      </Container>
    </div>
  )
}
